import React, { useState } from 'react';
import axios from 'axios';
import JobsProcessesPage from '../AppUtils/CreateOpportunitiesUtils/JobsProcessesPage';
import { Box, Button, FormControl, Stack, TextField, Typography } from '@mui/material';
import colors from '../styles/colors';
import messages from '../utilities/messages';
import { useSnackbar } from 'notistack';
import { register } from '../utilities/urls';
import componentStyles from '../styles/componentStyles';
import LoadingModal from './Loading';
import SubHeader from './web/subHeader';
import globalStyles from '../utilities/styles';
import Footer from './web/footer';
import Header from './web/header';

function LoginPage({ headerTitle, name, setAvailableCompanies, setIsLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  // const [isLoggedIn, setIsLoggedIn] = useState(false); // State to track login status

  const handleLogin = async () => {
    try {
      setLoading(true);
      const response = await axios.post(register, { name, username, password });

      if (!response || response.data?.error) {
        enqueueSnackbar(response.data.error, { variant: 'error' });
      }
      else if (
        response.data.message.saveCredentialsForUser &&
        response.data.message.saveCredentialsToSecrets.createdARN &&
        response.data.companies.length > 0
      ) {
        setAvailableCompanies(response.data.companies)
        setIsLoggedIn(true); // Set login status to true on success
        setLoading(false);
        // window.location.href = 'https://kivensferrer.github.io/hide/apps/mock-opportunities/'
      }
    } catch (error) {
      const errorMessage = (error.response && error.response.data.error) || error.message;
      enqueueSnackbar(errorMessage, { variant: 'error' });
      setIsLoggedIn(false);
      setLoading(false);
      console.error('Login failed', error);
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', }}>
        <Header title={headerTitle}
        />
        <SubHeader title={messages.login.headerTitle} subTitle={messages.login.headerSubtitle} />
        <FormControl size='small' sx={{ p: '20px 0px', alignItems: 'center' }} display='flex' flexDirection={'column'}>
          <Stack sx={{ width: globalStyles.fieldWidth }}>
            <Typography variant="caption" color="textSecondary" fontWeight='bold'>
              UKG Username
            </Typography>
            <TextField
              variant="outlined"
              placeholder="Enter UKG Username"
              margin="dense"
              size="small"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Stack>
        </FormControl>
        <FormControl size='small' sx={{ p: '20px 0px', alignItems: 'center' }} display='flex' flexDirection={'column'}>
          <Stack sx={{ width: globalStyles.fieldWidth }}>
            <Typography variant="caption" color="textSecondary" fontWeight='bold'>
              UKG Password
            </Typography>
            <TextField

              variant="outlined"
              type='password'
              placeholder="Enter UKG Password"
              margin="dense"
              size="small"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Stack>
        </FormControl>
        <Footer
          submitTitle='Connect'
          handleSubmit={handleLogin}
        />
      </Box>
      <LoadingModal isLoading={loading} message='Logging In...' />
    </>
  );
}

export default LoginPage;
